import React, { useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import ExportApi from "../api/ExportApi";
import CryptoJS from 'crypto-js';
import { toast } from "react-toastify";

const Signup = ({
  propEmail = "" , 
  modal = () => {},
  setSignup = () => {},
  setForgot = () => {},
  windowEvent = false,
  customButtonStyle
}) => {
 
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState(propEmail);
   const [password, setPassword] = useState("");
  const [opt_email, setOtpEmail] = useState(true);
  const [newsletter, setNewsletter] = useState(false);
  const [count, setCount] = useState(0);
  const [error, setError] = useState("");
  const [passwordStatus, setPasswordStatus] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [checkErrorMessage, setCheckErrorMessage] = useState();
  const [isPasswordValid, setIsPasswordValid] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const emailInputRef = useRef(null);

  const handlePasswordChange = (value) => {
    setPassword(value);
    validatePassword(value);
  };

const validatePassword = (value) => {
  const errors = [];

  if (value.length < 8) {
    errors.push("8+ characters");
  }
  if (!/[a-z]/.test(value)) {
    errors.push("1 lower");
  }
  if (!/[A-Z]/.test(value)) {
    errors.push("1 upper");
  }
  if (!/\d/.test(value)) {
    errors.push("1 number");
  }
  if (!/[@$!%*?&]/.test(value)) {
    errors.push("1 symbol");
  }

  const message = errors.join(", ");
  setErrorMessage(message);
  setIsPasswordValid(errors.length === 0);
};

  const validateName = (name) => {
    // Allow only alphabets and spaces
    return /^[A-Za-z\s]+$/.test(name);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const data = localStorage.getItem("utm_attribute");
    const utm_attribute = data ? JSON.parse(data) : null;

    //handling affiliate attribution
    const affiliate_attribution_obj = localStorage.getItem("affiliate_attribution");
    let affiliate_attribution;

    if (affiliate_attribution_obj) {
      const affiliate_attribution_parsed = JSON.parse(affiliate_attribution_obj);
      affiliate_attribution = {
        affiliate_id: affiliate_attribution_parsed.affiliate_id ?? null,
        affiliate_seen_at: affiliate_attribution_parsed.affiliate_seen_at ?? null,
      }
    }
    else {
      affiliate_attribution = {
        affiliate_id: null,
        affiliate_seen_at: null
      }
    }

  // Trim input values to remove any leading or trailing whitespace
  const trimmedFirstName = firstname.trim();
  const trimmedLastName = lastname.trim();
  const trimmedEmail = email.toLowerCase().trim();
  const trimmedPassword = password.trim();

  // Check if any of the fields are empty after trimming
  if (!trimmedFirstName || !trimmedLastName || !trimmedEmail || !trimmedPassword) {
    setError("Fields cannot be empty.");
    return;
  }

  // Check if the password is valid
  if (!isPasswordValid) {
    setError("Password must meet the requirements.");
    return;
  }

  // Check if both first name and last name are invalid
  if (!validateName(trimmedFirstName) && !validateName(trimmedLastName)) {
    setError("First name and last name must only contain letters.");
    return;
  }

  // Check if the first name is invalid
  if (!validateName(trimmedFirstName)) {
    setError("First name must contain letters only.");
    return;
  }

  // Check if the last name is invalid
  if (!validateName(trimmedLastName)) {
    setError("Last name must contain letters only.");
    return;
  }



  // Proceed if all fields are valid
  if (trimmedFirstName && trimmedLastName && trimmedEmail && trimmedPassword) {
    if (newsletter) {
      setCount(1);
      setError("");

      // Call the register API with encrypted values
      ExportApi.Register(trimmedFirstName, trimmedLastName, trimmedEmail, trimmedPassword, opt_email , utm_attribute , affiliate_attribution)
        .then((resp) => {
          if (resp.data.success) {
            fireSignupEvent(trimmedEmail);
            let data = resp.data.data;
            localStorage.setItem("favourite", JSON.stringify(data?.favourite));

            const loginTime = new Date().getTime();
            localStorage.setItem("loginTime", loginTime);
            localStorage.setItem("tokenuser", JSON.stringify(data));
            let Data = data?.shipping_address?.street;
            localStorage.setItem("useraddress", JSON.stringify(Data));

            if(utm_attribute){
              localStorage.removeItem("utm_attribute");
            }

            if (location.pathname === "/") {
              navigate("/profile/" + resp?.data?.data?.id);
              modal();
            } else {
              navigate(location.href);
              modal();
               if(windowEvent){
                window.dispatchEvent(new Event("handlingUserAction"));
              }
            }
            setCount(0);

            window.dispatchEvent(new Event("authChange"));
          } else {
            toast.error(resp?.data?.message);
            setCount(0);
          }
        })
        .catch((err) => console.log(err));
    } else {
      setCount(0);
      setError("Please Select Term and Condition");
    }
  } else {
    setCount(0);
    setError("All Fields are Required");
  }
};

  const HandleSubscribeEmail = async (email, firstname) => {
    let data = { email, firstname };
    const response = await fetch(
      "https://api.sendgrid.com/v3/contactdb/recipients",
      {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    const result = await response.json();
 
    return;
  };

  return (
    <div>
       <div>
         <p
          className="max-w-3xl mx-auto m-0"
          style={{
            fontSize: "clamp(0.9rem, 1.2vw, 1.125rem)",
            textAlign: "left",
            color : "#212529",
            fontWeight: 500
          }}
        >
          Create a free account to buy, sell, and place bids/asks on GPUs like
          stocks.
        </p>
      </div>
      <form className="form w-100 p-0" onSubmit={handleSubmit}>
        <div className="input-container w-100">
          <label className="label fs-5 mb-2">First Name: </label>
          <input
            type="text"
            name="firstname"
            className="input form-control"
            placeholder="First Name"
            value={firstname}
            required
            onChange={(e) => setFirstname(e.target.value)}
          />
        </div>
        <div className="input-container w-100">
          <label className="label fs-5 mb-2">Last Name: </label>
          <input
            type="text"
            name="lastname"
            className="input form-control"
            placeholder="Last Name"
            value={lastname}
            required
            onChange={(e) => setLastname(e.target.value)}
          />
        </div>
        <div className="input-container w-100">
          <label className="label fs-5 mb-2">Email: </label>
          <input
            ref={emailInputRef}
            type="text"
            name="email"
            className="input form-control"
            placeholder="Email"
            value={email}
            pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
            required
            onChange={(e) => {
              const cursorPos = e.target.selectionStart;
              setEmail(e.target.value.toLowerCase());
              setTimeout(() => emailInputRef.current?.setSelectionRange(cursorPos, cursorPos), 0);
            }}
          />
        </div>
        <div className="input-container w-100">
          <label className="label fs-5 mb-2">Password: </label>

          <div className="w-100 d-block position-relative">
            <input
              type={passwordStatus ? "text" : "password"}
              name="password"
              className="input form-control position-relative"
              placeholder="Password "
              value={password}
              required
              // onChange={(e) => handleChange(e.target.value)}
              onChange={(e) => handlePasswordChange(e.target.value)}
            />
            {passwordStatus ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-eye-slash-fill position-absolute signup_eye_icon"
                viewBox="0 0 16 16"
                onClick={() => setPasswordStatus(!passwordStatus)}
              >
                <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7.029 7.029 0 0 0 2.79-.588zM5.21 3.088A7.028 7.028 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474L5.21 3.089z" />
                <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829l-2.83-2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12-.708.708z" />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="19"
                height="19"
                fill="currentColor"
                class="bi bi-eye-fill position-absolute signup_eye_icon"
                viewBox="0 0 16 16"
                onClick={() => setPasswordStatus(!passwordStatus)}
              >
                <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
              </svg>
            )}
          </div>
        </div>
         {errorMessage && (
          <span style={{ fontWeight: "bold", color: "red" }}>
            {`Requirements: ${errorMessage}`}
          </span>
        )}

        <div className="newslatter mt-2">
          <input
            type="checkbox"
            name="checkbox"
            checked={opt_email ? true : false}
            onChange={() => setOtpEmail(!opt_email)}
          />
          <p
            className="max-w-3xl mx-auto m-0"
            style={{
              fontSize: "clamp(0.9rem, 1.2vw, 1.125rem)",
              textAlign: "left",
              color: "#212529",
              fontWeight: 500
            }}
          >
            New deals, marketplace tips and important account updates. No spam.
          </p>
        </div>

        <div className="newslatter mt-2">
          <input
            type="checkbox"
            name="checkbox"
            checked={newsletter ? true : false}
            onChange={() => setNewsletter(!newsletter)}
          />
          <p
            className="max-w-3xl mx-auto m-0"
            style={{
              fontSize: "clamp(0.9rem, 1.2vw, 1.125rem)",
              textAlign: "left",
              color: "#212529",
              fontWeight: 500
            }}
          >
            By signing up you agree to the{" "}
            <Link to="/terms">Terms of Service </Link> and{" "}
            <Link to="/PrivacyPolicy">Privacy Policy</Link>
          </p>
        </div>

        {
          error && error?.trim !== "" && (
            <p style={{ color: "red", textAlign: "center", fontSize: "20px" }}>
              {error}
            </p>
          )
        }

        <div className="w-100 d-flex flex-row gap-1 mb-2">
          <button
            type="submit"
            className="d-block custom-signup"
            id={`${!customButtonStyle ? "login-btn" : "login-btn-custom" }`}
          >
            {count == 1 ? "loading..." : "SignUp"}
          </button>

          <button
            type="button"
            className="d-block custom-signup"
            id={`${!customButtonStyle ? "login-btn" : "login-btn-custom" }`}
            onClick={() => {
              setSignup(false);
              setForgot(false)
            }}
          >
            Login
          </button>
       </div>
      </form>
    </div>
  );
};

export default Signup;
